import { defineMessages } from 'react-intl'

const scope = `procurify.platform.legal-entities.features.view-legal-entity-details.views.legal-entity-details-view`

export default defineMessages({
  statusActive: {
    id: `${scope}.statusActive`,
    defaultMessage: 'Active',
  },
  statusInactive: {
    id: `${scope}.statusInactive`,
    defaultMessage: 'Inactive',
  },
  actionEdit: {
    id: `${scope}.actionEdit`,
    defaultMessage: 'Edit entity',
  },
  actionDisable: {
    id: `${scope}.actionDisable`,
    defaultMessage: 'Disable entity',
  },
  actionEnable: {
    id: `${scope}.actionEnable`,
    defaultMessage: 'Enable entity',
  },
  lastActiveEntityTooltip: {
    id: `${scope}.lastActiveEntityTooltip`,
    defaultMessage: 'Your organization needs at least one active entity.',
  },
  fieldBaseCurrency: {
    id: `${scope}.fieldBaseCurrency`,
    defaultMessage: 'Base currency',
  },
  fieldExternalId: {
    id: `${scope}.fieldExternalId`,
    defaultMessage: 'External ID',
  },
  fieldCountry: {
    id: `${scope}.fieldCountry`,
    defaultMessage: 'Country',
  },
  noneAdded: {
    id: `${scope}.noneAdded`,
    defaultMessage: 'None added',
  },
})
